import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import qs from 'qs'
import { getToken } from '@/common/auth'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000, // request timeout
  crossDomain: true
  // headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // console.log(config.data)

    if (config.method === 'post') {
      var dd = qs.stringify(config.data)
      // console.log(dd)
      // console.log(dd.substr(0, 9))
      if (dd.indexOf('fun=upimg') > -1) {
        config.headers['Content-Type'] = 'multipart/form-data'
      } else {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        config.data = dd // qs.stringify(config.data)
        // if (dd.indexOf('fun=wxmp_user_save') > -1) {
        //   config.timeout = 1200000
        // }
      }
    }
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['wdtoken'] = getToken()
    } else {
      // config.headers['wdtoken'] = ''
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  
  response => {
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    if (res.rs !== 0) {
      // Message({
      //   message: res.msg || 'Error',
      //   type: 'error',
      //   duration: 5 * 1000
      // })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.rs === -2) {
        // to re-login
        MessageBox.confirm('请先登录', '操作提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
			console.log("请先登录");
        })
      }
      return Promise.reject(res)
    } else {
      // console.log(res)
      return res
    }
  },
  error => {
    Message({
      message: error.msg,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)
export default service
